import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CheckCircle2, XCircle } from "lucide-react";
import { PageHeader, EmptyState, StatCard } from "@/components/dash/Common";
import { FullLoader } from "@/components/ProtectedRoute";
import { useApi } from "@/hooks/useApi";
import { fmtDateTime } from "@/lib/format";

const LETTERS = "ABCDE";

function QuestionReview({ q, idx, chosen }) {
  const correct = chosen === q.answer_index;
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-6" data-testid={`review-question-${idx + 1}`}>
      <div className="flex gap-3">
        {correct ? <CheckCircle2 className="h-5 w-5 text-emerald-500 shrink-0" /> : <XCircle className="h-5 w-5 text-red-500 shrink-0" />}
        <p className="text-slate-900"><span className="font-mono text-xs text-slate-500 mr-2">{idx + 1}.</span>{q.text}</p>
      </div>
      <div className="mt-4 space-y-2 pl-8">
        {q.options.map((o, i) => {
          const cls = i === q.answer_index ? "border-emerald-300 bg-emerald-50" : i === chosen ? "border-red-300 bg-red-50" : "border-slate-200";
          return <div key={i} className={`rounded border px-3 py-2 text-sm ${cls}`}><span className="font-mono font-bold mr-2">{LETTERS[i]}.</span>{o}</div>;
        })}
        {chosen === undefined && <p className="text-xs text-slate-500">Tidak dijawab</p>}
        {q.explanation && <div className="mt-3 rounded bg-slate-50 p-3 text-sm text-slate-700"><span className="font-semibold">Pembahasan: </span>{q.explanation}</div>}
      </div>
    </div>
  );
}

export default function ExamReview() {
  const { id } = useParams();
  const { data, loading, error } = useApi(`/student/attempts/${id}`);
  if (loading) return <FullLoader />;
  if (error) return <EmptyState text={error} />;
  const { attempt, exam, questions } = data;
  return (
    <div data-testid="exam-review-page">
      <Link to="/siswa/ujian" className="text-sm text-slate-500 flex items-center gap-1 mb-4 hover:text-slate-900" data-testid="back-to-exams-link"><ArrowLeft className="h-4 w-4" />Daftar ujian</Link>
      <PageHeader eyebrow="Hasil & Pembahasan" title={exam.title || attempt.exam_title} description={`Dikumpulkan ${fmtDateTime(attempt.submitted_at)}`} />
      <div className="grid grid-cols-3 gap-4 mb-8">
        <StatCard dark label="Nilai" value={attempt.score} testid="review-score" />
        <StatCard label="Benar" value={`${attempt.correct}/${attempt.total}`} />
        <StatCard label="Durasi" value={`${Math.round((attempt.duration_sec || 0) / 60)} mnt`} />
      </div>
      {questions.length === 0 ? <EmptyState text="Pembahasan untuk ujian ini tidak ditampilkan." /> : (
        <div className="space-y-4">{questions.map((q, i) => <QuestionReview key={q.id} q={q} idx={i} chosen={attempt.answers[q.id]} />)}</div>
      )}
    </div>
  );
}
